import { render, staticRenderFns } from "./Dots.vue?vue&type=template&id=d6654bea&scoped=true"
import script from "./Dots.vue?vue&type=script&lang=ts"
export * from "./Dots.vue?vue&type=script&lang=ts"
import style0 from "./Dots.vue?vue&type=style&index=0&id=d6654bea&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6654bea",
  null
  
)

export default component.exports